import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InteractionStatus } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { MessageBarButton, Spinner, SpinnerSize } from '@fluentui/react';
import { useSignInFunction, useSignOutFunction } from '@msrceng/auth';
/**
 * A component that renders controls for the user to sign in or sign out.
 */
export const MessageAuthErrorControls = ({ error, }) => {
    if (!error) {
        return null;
    }
    // Only show "sign in again" button if the error is one of the following:
    if ((error === null || error === void 0 ? void 0 : error.errorCode) === 'temporarily_unavailable' ||
        (error === null || error === void 0 ? void 0 : error.errorCode) === 'server_error' ||
        (error === null || error === void 0 ? void 0 : error.errorCode) === 'interaction_required' ||
        (error === null || error === void 0 ? void 0 : error.errorCode) === 'consent_required' ||
        (error === null || error === void 0 ? void 0 : error.errorCode) === 'user_cancelled' ||
        (error === null || error === void 0 ? void 0 : error.errorCode) === 'login_required' ||
        (error === null || error === void 0 ? void 0 : error.errorCode) === 'invalid_grant') {
        return _jsx(MessageAuthErrorControlsSignInOut, {});
    }
    return null;
};
/** Sign in and Sign out button for MessageAuthErrorControls. */
export const MessageAuthErrorControlsSignInOut = () => {
    const onSignIn = useSignInFunction();
    const onSignOut = useSignOutFunction();
    const { inProgress } = useMsal();
    const isLoadingSignIn = inProgress === InteractionStatus.Login;
    const isLoadingSignOut = inProgress === InteractionStatus.Logout;
    return (_jsxs("div", { children: [_jsxs(MessageBarButton, Object.assign({ iconProps: { iconName: 'Signin' }, disabled: isLoadingSignIn, primary: true, onClick: () => onSignIn() }, { children: ["Sign in again", isLoadingSignIn && _jsx(Spinner, { size: SpinnerSize.small })] })), _jsxs(MessageBarButton, Object.assign({ iconProps: { iconName: 'SignOut' }, disabled: isLoadingSignOut, onClick: () => onSignOut() }, { children: ["Sign out", isLoadingSignIn && _jsx(Spinner, { size: SpinnerSize.small })] }))] }));
};
